// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { CategoryModel } from "@insite/client-framework/Types/ApiModels";
import { getPreBookCategories } from "@synd/App/Services/CategoriesService";

type GetFeaturedCategoriesParameter = {
    onSuccess?: (result: CategoryModel[]) => void;
};

type HandlerType = ApiHandler<GetFeaturedCategoriesParameter, CategoryModel[]>;

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getPreBookCategories();
    } catch (error) {
        props.apiResult = [];
        logger.error(error);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameters, RequestDataFromApi, ExecuteOnSuccessCallback];

const loadPreBookCollections = createHandlerChainRunner(chain, "loadPreBookCollections");

export default loadPreBookCollections;
